import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

import { ConfigService} from '../config/config-service';
import { SessionService } from './session.service';
import { Empresa } from '../models/empresa';
import { environment } from '../../environments/environment';

@Injectable()
export class EmpresaService {
	private config: ConfigService;
	private _token: any;
	private host_api: String;
	private dbname: string;
	public factelec_api: String;

	constructor(
		private http: Http,
		private ss: SessionService,
	) {
		this.config = new ConfigService();
		this.host_api = this.ss.getData('host_api');
		this._token = sessionStorage.getItem('api-token');
		this.dbname = this.ss.getData('dbname');
		this.factelec_api = environment.factelec_api;
	}

	getAll(host_api,dbname,api_token) {
		let url = host_api + '/empresas' ;
		let headers = new Headers({ 'Accept': 'application/json' });
		headers.append('Authorization', "Bearer "+ api_token);
		headers.append('dbname', dbname);
		let options = new RequestOptions({ headers: headers });

		return this.http.get(url, options).map((res:Response) => {	
			return this.config.onSuccessResponse(res);
		}).catch((error: any) => {
			return this.config.onErrorResponse(error);
		});		
	}

	getById(id, qs="") {
		let url = this.host_api + '/empresas/' + id +qs;
		let headers = new Headers({ 'Accept': 'application/json' });
		headers.append('Authorization', "Bearer "+ this._token);
		headers.append('dbname', this.dbname);
		let options = new RequestOptions({ headers: headers });

		return this.http.get(url, options).map((res:Response) => {	
			return this.config.onSuccessResponse(res);
		}).catch((error: any) => {
			return this.config.onErrorResponse(error);
		});		
	}

	save(empresa) {
		let url = this.host_api + '/empresas';
		let params = empresa;
		let headers = new Headers({ 'Content-type': 'application/json' });
		headers.append('Authorization', "Bearer "+ this._token);
		headers.append('dbname', this.dbname);

		let options = new RequestOptions({ headers: headers });

		return this.http.post(url, params, options).map((res:Response) => {	
			return this.config.onSuccessResponse(res);
		}).catch((error: any) => {
			return this.config.onErrorResponse(error);
		});		
		
	}

	update(empresa) {
		let url = this.host_api + '/empresas/' + empresa.id;
		let params = JSON.stringify(empresa);
		let headers = new Headers({ 'Content-type': 'application/json' });
		headers.append('Authorization', "Bearer "+ this._token);
		headers.append('dbname', this.dbname);

		let options = new RequestOptions({ headers: headers });

		return this.http.put(url, params, options).map((res:Response) => {	
			return this.config.onSuccessResponse(res);
		}).catch((error: any) => {
			return this.config.onErrorResponse(error);
		});		
	}

	delete(id) {
		var url = this.host_api + '/empresas/' + id + '/del';
		let params = {usuario_id: this.ss.getData('usuario_id')};
		let headers = new Headers({ 'Content-type': 'application/json' });
		headers.append('Authorization', "Bearer "+ this._token);
		headers.append('dbname', this.dbname);
		let options = new RequestOptions({ headers: headers });

		return this.http.put(url, params, options).map((res:Response) => {
			return this.config.onSuccessResponse(res);
		}).catch((error: any) => {
			return this.config.onErrorResponse(error);
		});		
	}

	ConfCorreo(ConfCorreo) {
		let url = this.factelec_api + '/' + this.ss.getData('fact_user') + '/configmail';
		let params = ConfCorreo;
		let headers = new Headers({ 'Content-type': 'application/json' });
		headers.append('Authorization', "Bearer "+ this.ss.getData('fact-api-token'));

		let options = new RequestOptions({ headers: headers });

		return this.http.post(url, params, options).map((res:Response) => {	
			return this.config.onSuccessResponse(res);
		}).catch((error: any) => {
			return this.config.onErrorResponse(error);
		});
	}

	CertDigital(CertDigital) {
		let url = this.factelec_api + '/' + this.ss.getData('fact_user') + '/certificado';
		let params = CertDigital;
		let headers = new Headers();
		//headers.append("Content-type","application/json");
		//headers.append("Content-type","multipart/form-data");
		headers.append('Authorization', "Bearer "+ this.ss.getData('fact-api-token'));

		let options = new RequestOptions({ headers: headers });

		return this.http.post(url, params, options).map((res:Response) => {	
			return this.config.onSuccessResponse(res);
		}).catch((error: any) => {
			return this.config.onErrorResponse(error);
		});
	}

	LogoEmpresa(empresa, id) {
		let url = this.factelec_api + '/' + this.ss.getData('fact_user') + '/empresas/logo/' + id;
		let params = (empresa);
		let headers = new Headers();
		headers.append('Authorization', "Bearer "+ this.ss.getData('fact-api-token'));
		let options = new RequestOptions({ headers: headers });

		return this.http.post(url, params, options).map((res:Response) => {	
			return this.config.onSuccessResponse(res);
		}).catch((error: any) => {
			return this.config.onErrorResponse(error);
		});
	}

	getLogo(id) {
		let url = this.factelec_api + '/' + this.ss.getData('fact_user') + '/empresas/getlogo/' + id + '?tk=' + this.ss.getData('fact-api-token');
		let headers = new Headers({ 'Accept': 'application/json' });
		//headers.append('Authorization', "Bearer "+ this.ss.getData('fact-api-token'));
		//headers.append('dbname', this.dbname);
		let options = new RequestOptions({ headers: headers });

		return this.http.get(url, options).map((res:Response) => {	
			return this.config.onSuccessResponse(res);
		}).catch((error: any) => {
			return this.config.onErrorResponse(error);
		});		
	}

	getConfApi(queryString: String = "") {
		let url = this.ss.getData('host_api') + '/conexion/factapi' + queryString;
		let headers = new Headers({ 'Accept': 'application/json' });
		headers.append('Authorization', "Bearer " + sessionStorage.getItem('api-token'));
		headers.append('dbname', this.ss.getData('dbname'));
		let options = new RequestOptions({ headers: headers });

		return this.http.get(url, options).map((res:Response) => {	
			return this.config.onSuccessResponse(res);
		}).catch((error: any) => {
			return this.config.onErrorResponse(error);
		});		
	}

	GetEmpresaID_Fact(ruc_empresa) {
		let qs = "?dni="+ruc_empresa+"&status=A&embed=certdigital,configmail";
		let url = this.factelec_api + '/' + this.ss.getData('fact_user')+ '/empresas' + qs;
		let headers = new Headers({ 'Accept': 'application/json' });
		headers.append('Authorization', "Bearer "+ this.ss.getData('fact-api-token'));
		let options = new RequestOptions({ headers: headers });

		return this.http.get(url, options).map((res:Response) => {
			return this.config.onSuccessResponse(res);
		}).catch((error: any) => {
			return this.config.onErrorResponse(error);
		});		
	}

}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/services/empresa.service.ts